import React from 'react';
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import '../../../static/styles/apiguide.scss';
import '../../../static/styles/dashboard.scss';

export default class ViewReservationList extends React.Component {
	constructor (props) {
		super(props);
	}

	render () {
		const col_number_8 = 8;
		const total_levels = 6;
		const level1 = 5;
		const level2 = 4;
		const level2_prefix = level1 - level2;
		const level3 = 3;
		const level3_prefix = level1 - level3;
		const level4 = 2;
		const level4_prefix = level1 - level4;
		const level5 = 1;
		const level5_prefix = level1 - level5;
		return (
			<div id={"view-reservation-list"}>
				{/*<h3 className={"mb0 mt40"}>12. 예약 데이터 API 조회하기 </h3>*/}
				<h3 className={"mb0 mt40"}>예약 목록 조회</h3>

				<div className="blog-post-meta">
					<span className="s-post">판매된 상품의 예약을 조회 할 수 있습니다. (기간 제한 : 1달 , 제공 데이터 수 제한 : 최대 10,000개)</span>
					<h3 className="request-method">
						<span className="label label-success">GET</span>
					</h3>
				</div>

				<div className="table-responsive">
					<table className="table table-striped">
						<tbody>
						<tr>
							<td>Path</td>
							<td>Example Endpoint</td>
						</tr>
						<tr>
							<td>/v1/marketplace/reservations</td>
							<td>
								https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/reservations
							</td>
						</tr>
						</tbody>
					</table>
				</div>

				<div className="table-responsive mt40">
					<h4>Request Parameters</h4>
					<table className="table table-striped">
						<tbody>
						<tr>
							<th colSpan="4" className="bold">Request Header</th>
						</tr>
						<tr>
							<th>Name</th>
							<th>Required</th>
							<th>Type</th>
							<th>Description</th>
						</tr>
						<tr>
							<td>Request-Vendor-Id</td>
							<td>O</td>
							<td>String</td>
							<td>벤더 아이디 요청</td>
						</tr>
						<tr>
							<th colSpan="4" className="bold"> Query Parameters</th>
						</tr>
						<tr>
							<th>Name</th>
							<th>Required</th>
							<th>Type</th>
							<th>Description</th>
						</tr>
						<tr>
							<td>pageSize</td>
							<td>X</td>
							<td>int</td>
							<td>페이지네이션: 한 페이지 크기. Default: 50</td>
						</tr>
						<tr>
							<td>startDate</td>
							<td>X</td>
							<td>String</td>
							<td>디폴트 오늘의 00:00:00, 날짜 형식 yyyy-MM-dd HH:mm:ss</td>
						</tr>
						<tr>
							<td>endDate</td>
							<td>X</td>
							<td>String</td>
							<td>디폴트 내일의 00:00:00, 날짜 형식 yyyy-MM-dd HH:mm:ss</td>
						</tr>
						<tr>
							<td>travelProductId</td>
							<td>X</td>
							<td>String</td>
							<td>여행상품 id</td>
						</tr>
						</tbody>
					</table>
				</div>

				<div className="table-responsive mt40">
					<h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>code</td>
                            <td>String</td>
                            <td>응답 코드</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>message</td>
                            <td>String</td>
                            <td>응답 메세지</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>data</td>
                            <td>responseDto</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>travelProductId</td>
                            <td>String</td>
                            <td>여행상품 id</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>travelItemId</td>
                            <td>String</td>
                            <td>Travel Item Id</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>travelRateId</td>
                            <td>String</td>
                            <td>Travel Rate Id</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>productDetailType</td>
                            <td>String</td>
                            <td>상품 상세 타입</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>checkInDate</td>
                            <td>String</td>
                            <td>CheckIn Date</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>checkOutDate</td>
                            <td>String</td>
                            <td>CheckOut Date</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>penaltyPrice</td>
                            <td>String</td>
                            <td>Penalty Price</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>arrivalTime</td>
                            <td>String</td>
                            <td>도착예정시간</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>roomRequest</td>
                            <td>String</td>
                            <td>객실요청사항</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>additionalInfo</td>
                            <td>String</td>
                            <td>업체 커스텀 필드</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>vendorItemPackageName</td>
                            <td>String</td>
                            <td>여행 상품명</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>vendorItemPackageId</td>
                            <td>String</td>
                            <td>벤더 아이템 패키지 아이디</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>vendorItemName</td>
                            <td>String</td>
                            <td>여행 상품 아이템명</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>vendorItemId</td>
                            <td>String</td>
                            <td>벤더 아이템 아이디</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>vendorId</td>
                            <td>String</td>
                            <td>Vendor Id</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>userPhoneNumber</td>
                            <td>String</td>
                            <td>유저 전화 번호r</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>userName</td>
                            <td>String</td>
                            <td>유저 이름</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>userEmail</td>
                            <td>String</td>
                            <td>유저 이메일</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>totalQuantity</td>
                            <td>Integer</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>ticketStatusType</td>
                            <td>Enum</td>
                            <td><table className="table table-striped">
                                <tbody>
                                <tr>
                                    <td>티켓 상태</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Value</th>
                                    <th>Description</th>
                                </tr>
                                <tr>
                                    <td>CONFIRM_PENDING</td>
                                    <td>예약대기</td>
                                </tr>
                                <tr>
                                    <td>CONFIRMED</td>
                                    <td>예약확정</td>
                                </tr>
                                <tr>
                                    <td>CANCEL_RECEIPT</td>
                                    <td>취소접수</td>
                                </tr>
                                <tr>
                                    <td>CANCEL_PROCEEDING</td>
                                    <td>취소중</td>
                                </tr>
                                <tr>
                                    <td>CANCEL_COMPLETE</td>
                                    <td>취소완료</td>
                                </tr>
                                <tr>
                                    <td>USED</td>
                                    <td>발행완료</td>
                                </tr>
                                </tbody>
                            </table></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>ticketNumber</td>
                            <td>String</td>
                            <td>티켓 번호</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>salePrice</td>
                            <td>BigDecimal</td>
                            <td>판매 가격</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>reservedAt</td>
                            <td>String</td>
                            <td>예약 일시</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>reservationModifiedAt</td>
                            <td>String</td>
                            <td>Reservation Update Time</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>reservationId</td>
                            <td>Long</td>
                            <td>Reservation Id</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>refundedAt</td>
                            <td>String</td>
                            <td>환불 일시</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>rateCategoryId</td>
                            <td>Long</td>
                            <td>RateCategory Id</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>purcahsedAt</td>
                            <td>String</td>
                            <td>구매 일시</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>productType</td>
                            <td>String</td>
                            <td>Product Type</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>productId</td>
                            <td>Long</td>
                            <td>프로덕트 아이디</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>orderId</td>
                            <td>Long</td>
                            <td>주문 아이디</td>
                        </tr>

                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>dailyInventoryPrices</td>
                            <td>List</td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>price</td>
                            <td>BigDecimal</td>
                            <td>Price</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>extraPrice</td>
                            <td>BigDecimal</td>
                            <td>Extra Price</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>extraDepositPrice</td>
                            <td>BigDecimal</td>
                            <td>Extra Deposit Price</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>discountedSalePrice</td>
                            <td>BigDecimal</td>
                            <td>Discounted Sale Price</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>depositPrice</td>
                            <td>BigDecimal</td>
                            <td>Deposit Price</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td colSpan={level3}>date</td>
                            <td>BigDecimal</td>
                            <td>Date</td>
                        </tr>

                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>couponSrl</td>
                            <td>Long</td>
                            <td>Coupon Serial Number</td>
                        </tr>
                        </tbody>
                    </table>
				</div>

				<div className="table-responsive mt40">
					<div className="panel panel-default">
						<div className="panel-heading">
							{/*<h3 className="panel-title">응답값 예시</h3>*/}
							<a data-toggle="collapse" href="#responseReservationDto">Response Body Sample</a>
						</div>
						<div id="responseReservationDto" className="panel-collapse collapse">
							<div className="panel-body">
                    <pre className="ty01">
                        {`
{
    "code": 200,
    "message": "SUCCESS",
    "data": {
        "success": true,
        "results": {
            "totalPages": 3,
            "totalElements": 121,
            "sort": null,
            "size": 50,
            "numberOfElements": 50,
            "number": 0,
            "last": false,
            "first": true,
            "content": [
                {
                    "travelProductId": "a5901dc1-9080-4d50-a2cb-7e7b8d9aa061",
                    "travelItemId": "15c366c9-1249-48bd-8abd-44e5ba2b2adf",
                    "travelRateId": null,
                    "productDetailType": "HOTEL",
                    "penaltyPrice": null,
                    "arrivalTime": "",
                    "roomRequest": "더블배드해주세요^^",
                    "additionalInfo": null,
                    "vendorItemPackageName": "씨클라우드호텔레지던스",
                    "vendorItemPackageId": 100000068296,
                    "vendorItemName": "슈페리어 하프오션 랜덤배정 기본요금(조식불포함)",
                    "vendorItemId": 5631440404,
                    "vendorId": "A12345678",
                    "userPhoneNumber": "010-1234-5678",
                    "userName": "abc",
                    "userEmail": "test@naver.com",
                    "totalQuantity": 1,
                    "ticketStatusType": "USED",
                    "ticketNumber": "BD8543-24000123456789",
                    "salePrice": 66000,
                    "reservedAt": "2021-02-12 00:00:00",
                    "reservationModifiedAt": "2021-01-20 23:24:29",
                    "reservationId": 12345678,
                    "refundedAt": null,
                    "rateCategoryId": 123451,
                    "purchasedAt": "2021-01-20 23:24:04",
                    "productType": "ACCOMMODATION",
                    "productId": 347244742,
                    "orderId": 24000123456789,
                    "dailyInventoryPrices": [
                        {
                            "price": 66000,
                            "extraPrice": 0,
                            "extraDepositPrice": 0,
                            "discountedSalePrice": 66000,
                            "depositPrice": 58740,
                            "date": "2021-02-12"
                        }
                    ],
                    "couponSrl": 2400112344567,
                    "checkOutDate": "2021-02-13",
                    "checkInDate": "2021-02-12"
                },
                {
                    "travelProductId": "a5901dc1-9080-4d50-a2cb-7e7b8d9aa061",
                    "travelItemId": "8b78ce04-4df0-4016-971e-114e29ef0c7f",
                    "travelRateId": null,
                    "productDetailType": "HOTEL",
                    "penaltyPrice": "0",
                    "arrivalTime": "",
                    "roomRequest": "",
                    "additionalInfo": null,
                    "vendorItemPackageName": "씨클라우드호텔레지던스",
                    "vendorItemPackageId": 100000068296,
                    "vendorItemName": "슈페리어 트윈 비전망 -> 하프오션뷰 기본요금(조식불포함)",
                    "vendorItemId": 5631440410,
                    "vendorId": "A11223344",
                    "userPhoneNumber": "010-1234-5678",
                    "userName": "xyz",
                    "userEmail": "test222@coupang.com",
                    "totalQuantity": 1,
                    "ticketStatusType": "CANCEL_COMPLETE",
                    "ticketNumber": "E583E7-5000123456789",
                    "salePrice": 121000,
                    "reservedAt": "2021-02-11 00:00:00",
                    "reservationModifiedAt": "2021-01-20 21:13:13",
                    "reservationId": 11223344,
                    "refundedAt": "2021-01-22 13:51:44",
                    "rateCategoryId": 11111,
                    "purchasedAt": "2021-01-20 21:13:04",
                    "productType": "ACCOMMODATION",
                    "productId": 347244742,
                    "orderId": 5001122334455,
                    "dailyInventoryPrices": [
                        {
                            "price": 55000,
                            "extraPrice": 0,
                            "extraDepositPrice": 0,
                            "discountedSalePrice": 55000,
                            "depositPrice": 48950,
                            "date": "2021-02-11"
                        },
                        {
                            "price": 66000,
                            "extraPrice": 0,
                            "extraDepositPrice": 0,
                            "discountedSalePrice": 66000,
                            "depositPrice": 58740,
                            "date": "2021-02-12"
                        }
                    ],
                    "couponSrl": 5112233445566,
                    "checkOutDate": "2021-02-13",
                    "checkInDate": "2021-02-11"
                },
                {
                    "travelProductId": "a5901dc1-9080-4d50-a2cb-7e7b8d9aa061",
                    "travelItemId": "8b78ce04-4df0-4016-971e-114e29ef0c7f",
                    "travelRateId": null,
                    "productDetailType": "HOTEL",
                    "penaltyPrice": "0",
                    "arrivalTime": "",
                    "roomRequest": "",
                    "additionalInfo": null,
                    "vendorItemPackageName": "씨클라우드호텔레지던스",
                    "vendorItemPackageId": 100000068296,
                    "vendorItemName": "슈페리어 트윈 비전망 -> 하프오션뷰 기본요금(조식불포함)",
                    "vendorItemId": 5631440410,
                    "vendorId": "A00112233",
                    "userPhoneNumber": "010-1111-2222",
                    "userName": "abc",
                    "userEmail": "test1234@coupang.com",
                    "totalQuantity": 1,
                    "ticketStatusType": "CANCEL_COMPLETE",
                    "ticketNumber": "28849C-5001122334455",
                    "salePrice": 121000,
                    "reservedAt": "2021-02-11 00:00:00",
                    "reservationModifiedAt": "2021-01-20 21:11:32",
                    "reservationId": 11223344,
                    "refundedAt": "2021-01-22 13:51:43",
                    "rateCategoryId": 112345,
                    "purchasedAt": "2021-01-20 21:11:24",
                    "productType": "ACCOMMODATION",
                    "productId": 347244742,
                    "orderId": 5123412341234,
                    "dailyInventoryPrices": [
                        {
                            "price": 55000,
                            "extraPrice": 0,
                            "extraDepositPrice": 0,
                            "discountedSalePrice": 55000,
                            "depositPrice": 48950,
                            "date": "2021-02-11"
                        },
                        {
                            "price": 66000,
                            "extraPrice": 0,
                            "extraDepositPrice": 0,
                            "discountedSalePrice": 66000,
                            "depositPrice": 58740,
                            "date": "2021-02-12"
                        }
                    ],
                    "couponSrl": 5567856785678,
                    "checkOutDate": "2021-02-13",
                    "checkInDate": "2021-02-11"
                }
            ]
        },
        "failMessage": null
    }
}
                        `}
                    </pre>
							</div>
						</div>
					</div>
				</div>

				<div className="table-responsive">
					<table className="table table-striped">
						<tbody>
						<tr>
							<th>HTTP CODE</th>
							<th>message</th>
							<th>설명</th>
						</tr>
						<tr>
							<td>400</td>
							<td>Bad request</td>
							<td>요청 파라미터 값이 정확하지 않을 경우에 발생합니다
								<div>
									<a data-toggle="collapse" href="#errorMessagesforReservation">400 Error Messages</a>
								</div>
								<div id="errorMessagesforReservation" className="panel-collapse collapse">
									<div className="panel-body">
										<li>시간대는 {'<= {maxDays}'}일이어야됨</li>
										<li>VendorItemPackageIds의 수치는 {'<= {maxVips}'}이어야함</li>
										<li>시작일은 종료일보다 늦지 않아야함</li>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td>401</td>
							<td>Unauthorized Error</td>
							<td>잘못된 인증 정보</td>
						</tr>
						<tr>
							<td>403</td>
							<td>Forbidden Error</td>
							<td>클라이언트 에서 인증을 제공하였으나 접속 허가를 받지 못했을 경우에 발생합니다.</td>
						</tr>
						<tr>
							<td>410</td>
							<td>The resource has been permanently deleted</td>
							<td>리소스가 삭제되었을 경우 발생합니다</td>
						</tr>
						<tr>
							<td>412</td>
							<td>Precondition failed</td>
							<td>전제조건이 충족하지 않아 요청이 처리되지 않을 경우에 발생합니다</td>
						</tr>
						<tr>
							<td>429</td>
							<td>Too many requests</td>
							<td>요청이 많을 경우 발생합니다</td>
						</tr>
						<tr>
							<td>504</td>
							<td>API Gateway response timeout</td>
							<td>API 게이트웨이 응답시간 초과할 경우 발생합니다</td>
						</tr>
						<tr>
							<td>521</td>
							<td>API provider server has error</td>
							<td>API 프로바이더 서버에 에러가 있을 경우 발생합니다</td>
						</tr>
						<tr>
							<td>524</td>
							<td>API provider to API gateway connection response timeout</td>
							<td>API 프로바이더에서 API 게이트웨이 연결 응답 시간 초과할 경우 발생합니다</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/ReservationAndCancellation/ReservationAndRefundAPI/ViewReservationList.jsx